import { useEffect, useState } from "react";
import {
  PHONE_BREAKPOINT,
  SHELL_BREAKPOINTS,
} from "../Config/responsive";

function getWidth() {
  if (typeof window === "undefined") {
    return 1440;
  }
  return window.innerWidth;
}

export default function useResponsive() {
  const [width, setWidth] = useState(getWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(getWidth());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    width,
    isPhone: width <= PHONE_BREAKPOINT,
    isCompactShell: width <= SHELL_BREAKPOINTS.compact,
    isDesktopShell: width > SHELL_BREAKPOINTS.compact,
  };
}